interface IconProps extends React.SVGProps<SVGSVGElement> {}

export const Cronos = ({ ...props }: IconProps) => (
  <svg
    width="100"
    height="100"
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_188_27163)">
      <circle
        cx="50"
        cy="50"
        r="50"
        fill="#002174"
      />
      <path
        d="M65.6319 23H34.2663L30.624 38.9964H69.4771L65.6319 23ZM39.8312 60.9659V50.3353L30.5226 44.4633L20 52.2591L34.3677 77.2659H40.1351L46.9142 70.8876V67.7492L39.8316 60.9659H39.8312Z"
        fill="white"
      />
      <path
        d="M60.1684 41.426H39.9323L43.2712 50.3353L42.2594 60.3582H57.8409L56.8291 50.3353L60.168 41.426H60.1684Z"
        fill="white"
      />
      <path
        d="M69.4771 44.3622L60.2698 50.3353V60.9659L53.2886 67.7492V70.8876L60.0677 77.1648H65.7337L80 52.2591L69.4774 44.3622H69.4771Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_188_27163">
        <rect
          width="100"
          height="100"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
);
